import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import CustomSnackbar from '../../../Components/CustomSnackbar';
import React, { useState, useEffect } from 'react';
import { loadingKtvAmplifierDataComponent } from '../../../LoadingData/LoadingDataComponents';
import { UpdateAmplifierModel } from '../../../UpdateData/UpdateCommunications';
import { DELETE_AMPLIFIER_ID_API_URL } from '../../../OpticApiConfig';
import { UpdateAmplifierActivity } from '../../../UpdateData/UpdateStatusComponent';


const AmplifierNodeCantonEditingDialog = ({ open, onClose, content, cantonRefresh}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [amplifierData, setAmplifierData] = useState([]);
  const [amplifierId, setAmplifierId] = useState("");
  const [statusActive, setStatusActive] = useState(false); 
  
  const token = localStorage.getItem('token');

   useEffect(() => {
      setStatusActive(content.statusKtvAmplifier === 1);
    }, [content.statusKtvAmplifier]);




  useEffect(() => {
    const fetchData = async () => {
      try {
        const [amplifierData, rankComponentData] = await Promise.all([
          loadingKtvAmplifierDataComponent(),
          //loadingRankComponentDataComponent(),
        ]);
        setAmplifierData(amplifierData);
       // setRankComponentData(rankComponentData);
      } catch (error) {
        // console.error("Error in fetchData:", error);
      }
    };
    fetchData();
  }, []);

  
  const handleCloseDialogs = () => {
    onClose();
  };


   const deleteAmplifier = async () => {
  
          if (!token) {
              showSnackbar('Ошибка! Токен не найден', 'snackbarWarning');
              return;
          }

          try {
              let apiAmplifier = `${DELETE_AMPLIFIER_ID_API_URL}?amplifierId=${content.id}`;

              const response = await fetch(apiAmplifier, { 
                  method: 'DELETE',
                  headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${token}` 
                  }
              });
  
              if (response.ok) {
                  showSnackbar('Компонент успешно удален', 'snackbarWarning');
                  setAmplifierData([]);
                  setAmplifierId("");
                  cantonRefresh();
                  handleCloseDialogs();
              } else {
                  showSnackbar('Ошибка удаления!', 'snackbarWarning');
              }
          } catch (error) {
              showSnackbar('Произошла ошибка!', 'snackbarWarning');
          }  
      };

  const handleChangeAmplifierSelect = (event) => {
    const selectedAmplifier = event.target.value;
    if (selectedAmplifier === "") {
      setAmplifierId("");
    } else {
      const selectedAmplifier2 = amplifierData.find(amplifier => 
        `${amplifier.id}` === selectedAmplifier
      );
      if (selectedAmplifier2) {
        setAmplifierId(selectedAmplifier2.id);
      }
    }
  };

  const updateModel = () => {
  
    if (amplifierId === "") {
      showSnackbar('Нет нужды в записи, усилитель без изменений!', 'snackbarOk');
    } else {
      UpdateAmplifierModel(content.id, amplifierId, showSnackbar, cantonRefresh );
    } 
  };

  const handleActiveCheckboxChange = () => {
       setStatusActive(!statusActive); 
     
       if(!statusActive){
         UpdateAmplifierActivity(content.id, 1, showSnackbar, content.authorId, cantonRefresh);
       }else{
         UpdateAmplifierActivity(content.id, 0, showSnackbar, content.authorId, cantonRefresh)
       }
      
    };



  

 

    return (
  
    <Dialog open={open} className="dialogStyle">
    
      <DialogContent>
     
      <img src='./amplifier.png' width='30' height='30' style={{ marginRight: "5px" }} />
       
      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset'}}>Редактирование усилителя</label>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe' }}>{content.id}</span></label>
      <br/>
      
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Усилитель: </label>

      <select className="selectStyleDrawer" 

        onChange={(event) => {
          handleChangeAmplifierSelect(event);
        }} >
        <option value="">{content.model}</option>
        {amplifierData.map(amplifier => (
          <option key={amplifier.id} value={amplifier.id}>{amplifier.model}</option>
        ))}
      </select>
      <button onClick={updateModel} class='buttonIsSaveDialog2'>Сохранить</button>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/>
      <div style={{ display: 'flex', alignItems: 'center' }}>
       <label style={{ color: '#292929', fontWeight: 'bold' }}>Состояние:</label>
          <input
            type="checkbox"
            checked={statusActive}
            onChange={handleActiveCheckboxChange}
            style={{ marginLeft: '10px' }}
          /> 
          <label
            style={{
              marginLeft: '5px',
              color: statusActive ? '#89da8dff' : '#ff8484ff',
            }}
          >
            {statusActive ? 'вкл' : 'выкл'}
          </label>
          </div>
        <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/>   
      <button onClick={deleteAmplifier} class='buttonIsDeleteModal2' style={{marginLeft:"0px"}}>Удалить</button>

      {/* <hr className='horizontalLineDialog'/>
      <button  class='buttonIsCoupFobDialog' onClick={openModalConnectionComponents}> Закрепить фоб</button> */}
      

      </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} class='buttonIsHideDrawer23'>
            Закрыть
          </Button>
        </DialogActions>


       {/* Snackbar */}
       <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />

      
    </Dialog>
  );
}

export default AmplifierNodeCantonEditingDialog;